/** @class Categories
 *
 * @desc
 * Class that displays all the `Categories` in the `Everplan` being viewed.
 */
import {Component} from 'react'
import {List, Map} from 'immutable'
import PropTypes from 'prop-types'

import CategoryDetails from './CategoryDetails'
import Form from '../../../../../shared_components/forms/v2/Form'
import Fields from '../../../../../shared_components/forms/v2/fields/index'
import {Download} from '../../../../../dashboard/src/components/corp_max/everplan_preview/header/Download'

import {categoriesWithItemResponseGroupMaps} from '../../../../../lib/plan_data/itemResponsesHelper'

import './categories.scss'

class Categories extends Component {
  constructor(props) {
    super(props)

    this.state = {categories: this.defaultCategory()}

    this.onChange = this.onChange.bind(this)
  }

  categoryItemList() {
    return this.props.categories
      .sortBy(category => category.get('sort-order'))
      .map(category => Map({
        label: category.get('name'),
        value: category.get('name'),
        id: category.get('id')
      }))
      .unshift(Map({label: 'All Categories', value: 'All Categories', id: 'all'}))
  }

  getCategoryByName(name) {
    return List([this.props.categories.find(category => category.get('name') === name)])
  }

  onChange() {
    const value = this.refs.form.formData().getIn(['categories', 'value'])
    if (value === 'All Categories')
      this.setState({categories: this.props.categories})
    else
      this.setState({categories: this.getCategoryByName(value)})
  }

  isQuarterbackOrFuneralHome() {
    return this.props.currentUser.get('quarterback') ||
    this.props.firm.get('firm-type') === 'funeral_home'
  }

  defaultCategory() {
    let category = this.props.categories
    const value = this.defaultCategoryValue()

    if (value !== 'All Categories')
      category = this.getCategoryByName(value)

    return category
  }

  defaultCategoryValue() {
    return this.isQuarterbackOrFuneralHome() ?
      'After I\'m Gone' :
      'All Categories'
  }

  categoriesWithItemResponses() {
    return categoriesWithItemResponseGroupMaps({categories: this.props.categories, itemResponses: this.props.itemResponses})
  }

  displayDownloadButton() {
    const activeClientSeats = this.props.clientSeats.filter(seat =>
      seat.get('status').toLowerCase() === 'active'
    )

    const hasActiveSeats = activeClientSeats.size > 0

    // Check if there are any active client seats with non-deceased owners
    let hasNonDeceasedOwner = false
    if (hasActiveSeats && this.props.owners) {
      hasNonDeceasedOwner = activeClientSeats.some(activeSeat => {
        const userId = activeSeat.get('user-id')
        const owner = this.props.owners.find(ownerItem => ownerItem.get('id') === userId)
        return owner && !owner.get('deceased')
      })
    }

    return hasActiveSeats && hasNonDeceasedOwner &&
      !this.props.currentUser.get('quarterback') &&
      this.props.firmConfig.get('write-access') === true
  }

  render() {
    const everplanId = this.props.everplanSummary.get('id')

    return (
      <div className='categories forms-playground'>
        <header className='categories-header'>
          <div className='header-content'>
            <h3>Everplan Details</h3>
            <div className='header-controls'>
              <div className='category-selection-container flex-container'>
                <span className='category-selection-prompt'>Show: </span>
                <Form ref='form' className='core category-selection'>
                  <Fields.Select
                    data={
                      Map({
                        id: 'categories',
                        items: this.categoryItemList(),
                        legend: '',
                        name: 'categories',
                        value: this.defaultCategoryValue()
                      })
                    }
                    onChange={this.onChange}
                  />
                </Form>
              </div>
              {this.displayDownloadButton() &&
                <Download
                  categoriesWithItemResponses={this.categoriesWithItemResponses()}
                  actor={this.props.actor}
                  context={this.props.context}
                  createResource={this.props.createResource}
                  everplanBundleDownload={this.props.everplanBundleDownload}
                  params={{everplanId}}
                  userConfig={this.props.userConfig}
                />
              }
            </div>
          </div>
        </header>
        {
          this.state.categories.sortBy(category => category.get('sort-order')).map(
            category => <CategoryDetails key={category.get('id')} {...this.props} category={category} />
          )
        }
      </div>
    )
  }
}

Categories.propTypes = {
  categories: PropTypes.instanceOf(List),
  currentUser: PropTypes.instanceOf(Map),
  context: PropTypes.string,
  clientSeats: PropTypes.instanceOf(List),
  actor: PropTypes.string,
  everplanSummary: PropTypes.instanceOf(Map),
  firm: PropTypes.instanceOf(Map),
  firmConfig: PropTypes.instanceOf(Map),
  owners: PropTypes.instanceOf(List),
  createResource: PropTypes.func,
  everplanBundleDownload: PropTypes.instanceOf(List),
  params: PropTypes.shape({
    everplanId: PropTypes.string
  }),
  itemResponses: PropTypes.instanceOf(List),
  userConfig: PropTypes.instanceOf(Map)
}

export default Categories
